module.exports = __webpack_public_path__ + "frontend-assets/img/kupelo.154fa512.png";